import pushToDataLayer from "./pushToDataLayer";
import ecommerceDataTemplate from "./ecommerceDataTemplate";

const notifyMeButtonClickEvent = itemData => {
  pushToDataLayer({
    notify_me_button_click: {
      component_name: "saved_list",
      ecommerce: ecommerceDataTemplate(itemData)
    }
  });
};

export default notifyMeButtonClickEvent;
